import $ from 'jquery';
import AuthHeader from '../../helpers/AuthHeader';
import BuildQS from '../../helpers/BuildQS';
import config from '../../config/config';

export const physicalFormatsService = {
	getPhysicalFormats,
};

function getPhysicalFormats(){
	return config.live ? getPhysicalFormatsLive() : getPhysicalFormatsStatic();
}

function getPhysicalFormatsLive() {
	let baseUrl = config.apis.secStat,
		qs = BuildQS({}),
		requestOptions = {
			headers: AuthHeader({'Content-Type': 'application/json'}),            
		};        
	baseUrl += '/physical_formats_collection?' + $.param(qs);
	return fetch(baseUrl, requestOptions)
	.then(res=>{   
		return res.json()
	})
}

function getPhysicalFormatsStatic() {
	let baseUrl = `${config.apis.sales}/api/static/sec/physical_formats_collection.json`;
	return fetch(baseUrl, {
		method: 'GET'
	})
	.then(res=>{   
		return res.json()
	})
}
